import { useParams } from 'react-router-dom';
import { useFetcher } from "../../hooks/Fetcher";
import { api } from "../../utils/api";

export default function ArtistPageLoader({ children }) {
    const { display_name } = useParams();

    const { data, error, isLoading } = useFetcher([display_name], async () => {
      const { data } = await api.get(`/profiles/display_name/${display_name}`, {
        validateStatus: (status) => status === 200
      });

      return data;
    });

    if (isLoading) {
      return (
        <p>Loading...</p>
      );
    }

    if (!data || error) {
      return (
        <p>Something went wrong.</p>
      );
    }

    return children({ artist: data });
}
